import { CellProps, Renderer } from "react-table";

export const PercentageCell: <T extends object>() => Renderer<CellProps<T, unknown>> = 
    () => {
        return (props) => props.value ? (
            <>
                {`${((props.value as number) * 100).toFixed(0)}%`}
            </>
        ) : (<></>)
}